import { render, staticRenderFns } from "./TableSimulations.vue?vue&type=template&id=64196766&"
import script from "./TableSimulations.vue?vue&type=script&lang=js&"
export * from "./TableSimulations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports